import { render, staticRenderFns } from "./AgencyImportExcludeDomains.vue?vue&type=template&id=70adf397"
import script from "./AgencyImportExcludeDomains.vue?vue&type=script&lang=js"
export * from "./AgencyImportExcludeDomains.vue?vue&type=script&lang=js"
import style0 from "./AgencyImportExcludeDomains.vue?vue&type=style&index=0&id=70adf397&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports